import { getCache as getSharedCache, revalidateCache } from '../core/cache';
import type { PathsWithMethod } from 'openapi-typescript-helpers';
import type { paths } from '../__generated__/access/database';

export const getCache = getSharedCache;

export type CacheablePaths = PathsWithMethod<paths, 'get'>;

export async function revalidate(key?: CacheablePaths | Array<CacheablePaths> | void, force?: boolean) {
	await revalidateCache(key as string | Array<string> | void, force);
}
